import type { UnleashContextValue } from '../type';
import UnleashContext from './context';

const useUnleash = () => UnleashContext.hook() as UnleashContextValue;

export default useUnleash;
